import { useMutation } from "@apollo/client/react";
import { UPDATE_TEMPLATE_MASKS } from "../../mutations/invoiceInterpretationTemplates/updateTemplateMasks";
import type { TemplateMaskInput } from "../../../models/InvoiceInterpretationInputs";

export const useUpdateTemplateMasks = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: (error: any) => void;
}) => {
  const [mutation, { loading, error, data }] = useMutation(
    UPDATE_TEMPLATE_MASKS,
    { onCompleted, onError }
  );

  const updateTemplateMasks = async ({
    masks,
    templateId,
    clientIdentifier,
  }: {
    templateId?: string;
    clientIdentifier?: string;
    masks: TemplateMaskInput[];
  }) => {
    return mutation({
      variables: {
        templateId,
        clientIdentifier,
        input: masks,
      },
    });
  };

  return { updateTemplateMasks, loading, error, data };
};
